import { Component } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrl: './confirm-dialog.component.scss',
  standalone: false,
})
export class ConfirmDialogComponent {
  title: string = '';
  message: string = '';
  htmlMessage: boolean = false;
  icon: string = '';
  iconColor: string = '';
  confirmButtonText: string = 'Bestätigen';
  confirmButtonIcon: string = '';
  cancelButtonText: string = 'Abbrechen';
  cancelButtonIcon: string = '';

  constructor(
    private dialogRef: DynamicDialogRef,
    private config: DynamicDialogConfig
  ) {
    this.title = this.config.data.title;
    this.message = this.config.data.message;
    this.htmlMessage = this.config.data.htmlMessage ?? false;
    this.icon = this.config.data.icon || '';
    this.iconColor = this.config.data.iconColor || '';
    this.confirmButtonText = this.config.data.confirmButtonText || 'Bestätigen';
    this.cancelButtonText = this.config.data.cancelButtonText || 'Abbrechen';
    this.confirmButtonIcon = this.config.data.confirmButtonIcon || '';
    this.cancelButtonIcon = this.config.data.cancelButtonIcon || '';
  }

  public closeDialog(confirmed: boolean) {
    this.dialogRef.close(confirmed);
  }
}
